<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function () {
  function updatePresale() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('input[name="id"]');
    var el = document.getElementById('presale-text');

    if (!variantInput || !el || !window.variantPresaleMap) return;

    var variantId = variantInput.value;
    var val = window.variantPresaleMap[variantId];

    if (val) {
      el.textContent = 'Pre-Order:' + val;
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  // 监听整个页面的点击，覆盖变体按钮/色块/下拉选项
  document.addEventListener('click', function () {
    setTimeout(updatePresale, 300);
  });

  // 如果变体是下拉框(select)形式，click 可能捕捉不到，额外加个 change 兜底
  document.addEventListener('change', function () {
    setTimeout(updatePresale, 300);
  });
})();